export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000/api',
  emailVerificationEnabled: true,
  developmentMode: true,
  stripe: {
    publishableKey: 'pk_test_51234567890abcdef' // Replace with your test key
  },
  paypal: {
    clientId: 'test_paypal_client_id' // Replace with your test client ID
  }
};
